module.exports = __webpack_public_path__ + "static/media/clue-2.9625ac20.svg";